import { createContext, useContext, useState, useEffect, useCallback } from "react";
import fr from "./locales/fr";
import en from "./locales/en";
import es from "./locales/es";
import de from "./locales/de";

const DICTS = { fr, en, es, de };

export const LANGS = [
  { code: "fr", label: "Français", flag: "🇫🇷", short: "FR" },
  { code: "en", label: "English", flag: "🇬🇧", short: "EN" },
  { code: "es", label: "Español", flag: "🇪🇸", short: "ES" },
  { code: "de", label: "Deutsch", flag: "🇩🇪", short: "DE" },
];

const STORAGE_KEY = "bbrgo_lang";

function getInitial() {
  try {
    // 1. Choix déjà enregistré par l'utilisateur => prioritaire
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && DICTS[saved]) return saved;
  } catch {}
  // Français par défaut (version principale présentée aux moteurs de recherche).
  // Les autres langues restent accessibles via le sélecteur (choix persistant).
  return "fr";
}

function resolve(dict, key) {
  return key.split(".").reduce((o, k) => (o && o[k] != null ? o[k] : undefined), dict);
}

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(getInitial);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {}
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((code) => {
    if (DICTS[code]) setLangState(code);
  }, []);

  const t = useCallback(
    (key, vars) => {
      let val = resolve(DICTS[lang], key);
      if (val === undefined) val = resolve(DICTS.fr, key);
      if (val === undefined) return key;
      if (vars && typeof val === "string") {
        Object.entries(vars).forEach(([k, v]) => {
          val = val.replace(new RegExp(`{${k}}`, "g"), v);
        });
      }
      return val;
    },
    [lang]
  );

  return <I18nContext.Provider value={{ lang, setLang, t, langs: LANGS }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
